// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__35QCz"};